// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staff-vip-page {
  display: flex;
  flex-direction: column;
}

.staff-vip-layout {
  display: grid;
  grid-template-columns: minmax(320px, 420px) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.staff-vip-form-card,
.staff-vip-list-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
}

.staff-vip-form-header h2,
.staff-vip-list-header h2 {
  margin: 0 0 6px;
  color: #0f172a;
}

.staff-vip-form-header p,
.staff-vip-list-header p {
  margin: 0;
  color: #64748b;
}

.staff-vip-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin: 20px 0 16px;
}

.staff-vip-form-card textarea,
.staff-vip-form-card input {
  width: 100%;
}

.staff-vip-list-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 18px;
}

.staff-vip-search {
  min-width: 260px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #dbe3ef;
  border-radius: 12px;
  padding: 10px 12px;
}

.staff-vip-search input {
  width: 100%;
  border: none;
  outline: none;
}

.staff-vip-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.staff-vip-item {
  border: 1px solid #fde68a;
  background: linear-gradient(180deg, #fffef7 0%, #ffffff 100%);
  border-radius: 14px;
  padding: 18px;
}

.staff-vip-item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.staff-vip-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f59e0b;
  color: #fff;
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.76rem;
  font-weight: 700;
}

.staff-vip-status {
  font-size: 0.8rem;
  font-weight: 700;
}

.status-à-venir,
.status-sans-horaire {
  color: #0369a1;
}

.status-arrivé {
  color: #15803d;
}

.status-en-retard {
  color: #b45309;
}

.staff-vip-item h3,
.staff-vip-item p {
  margin: 0 0 8px;
}

.staff-vip-time {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0;
  color: #475569;
}

.staff-vip-comments {
  color: #64748b;
}

.staff-vip-empty {
  border: 1px dashed #cbd5e1;
  border-radius: 14px;
  padding: 28px;
  text-align: center;
  color: #64748b;
}

@media (max-width: 960px) {
  .staff-vip-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .staff-vip-form-grid {
    grid-template-columns: 1fr;
  }

  .staff-vip-list-header {
    flex-direction: column;
  }

  .staff-vip-search {
    min-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/StaffVipVisitorsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".staff-vip-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.staff-vip-layout {\r\n  display: grid;\r\n  grid-template-columns: minmax(320px, 420px) minmax(0, 1fr);\r\n  gap: 24px;\r\n  align-items: start;\r\n}\r\n\r\n.staff-vip-form-card,\r\n.staff-vip-list-card {\r\n  background: #fff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);\r\n}\r\n\r\n.staff-vip-form-header h2,\r\n.staff-vip-list-header h2 {\r\n  margin: 0 0 6px;\r\n  color: #0f172a;\r\n}\r\n\r\n.staff-vip-form-header p,\r\n.staff-vip-list-header p {\r\n  margin: 0;\r\n  color: #64748b;\r\n}\r\n\r\n.staff-vip-form-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 16px;\r\n  margin: 20px 0 16px;\r\n}\r\n\r\n.staff-vip-form-card textarea,\r\n.staff-vip-form-card input {\r\n  width: 100%;\r\n}\r\n\r\n.staff-vip-list-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 16px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.staff-vip-search {\r\n  min-width: 260px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border: 1px solid #dbe3ef;\r\n  border-radius: 12px;\r\n  padding: 10px 12px;\r\n}\r\n\r\n.staff-vip-search input {\r\n  width: 100%;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.staff-vip-list {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.staff-vip-item {\r\n  border: 1px solid #fde68a;\r\n  background: linear-gradient(180deg, #fffef7 0%, #ffffff 100%);\r\n  border-radius: 14px;\r\n  padding: 18px;\r\n}\r\n\r\n.staff-vip-item-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.staff-vip-pill {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  background: #f59e0b;\r\n  color: #fff;\r\n  border-radius: 999px;\r\n  padding: 5px 10px;\r\n  font-size: 0.76rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.staff-vip-status {\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.status-à-venir,\r\n.status-sans-horaire {\r\n  color: #0369a1;\r\n}\r\n\r\n.status-arrivé {\r\n  color: #15803d;\r\n}\r\n\r\n.status-en-retard {\r\n  color: #b45309;\r\n}\r\n\r\n.staff-vip-item h3,\r\n.staff-vip-item p {\r\n  margin: 0 0 8px;\r\n}\r\n\r\n.staff-vip-time {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 12px 0;\r\n  color: #475569;\r\n}\r\n\r\n.staff-vip-comments {\r\n  color: #64748b;\r\n}\r\n\r\n.staff-vip-empty {\r\n  border: 1px dashed #cbd5e1;\r\n  border-radius: 14px;\r\n  padding: 28px;\r\n  text-align: center;\r\n  color: #64748b;\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .staff-vip-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .staff-vip-form-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .staff-vip-list-header {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .staff-vip-search {\r\n    min-width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
